

import { InfoCircleOutlined, LeftOutlined } from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  notification,
  Row,
  Select,
} from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { BASE_API_CONFIG } from "../../util/Api";
import axios from "axios";
import TextArea from "antd/lib/input/TextArea";
import { Option } from "antd/es/mentions";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import Upload from "../../components/Upload";
import { getLabel, isValidString } from "../../util/ApiHelper";
import { showAlert } from "../../util/helper";

const UpdatePolicyDetails = () => {
  const { isMobile } = useGetBreakpoints();
  const { loading } = useSelector(({ common }) => common);
  const authUser = useSelector(({ auth }) => auth.userData);
  const [policyIconFiles, setPolicyIconFiles] = useState([{ src: "" }]);
  const [referenceDocs, setReferenceDocs] = useState([{ src: "" }]);

  const token = authUser.token;
  const [form] = useForm();
  const history = useHistory();

  const handlePolicyIconUpload = (data) => {
    setPolicyIconFiles(prevFileList => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = data.src;
      if (updatedList.length < 4) {
        updatedList.push({ src: "" });
      }
      updatedList[data.index].originalName = data.originalName;
      return updatedList;
    });
  };

  const handlePolicyIconRemove = (data) => {
    setPolicyIconFiles(prevFileList => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = "";
      return updatedList;
    });
  };

  const handleReferenceDocUpload = (data) => {
    setReferenceDocs(prevFileList => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = data.src;
      if (updatedList.length < 4) {
        updatedList.push({ src: "" });
      }
      updatedList[data.index].originalName = data.originalName;
      return updatedList;
    });
  };

  const handleReferenceDocRemove = (data) => {
    setReferenceDocs(prevFileList => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = "";
      return updatedList;
    });
  };

  const policyIconUpload = () => (
    <div className="attachments">
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
        {policyIconFiles?.length > 0 ? (
          policyIconFiles.map((file, index) => (
            <Upload
              key={`policy-icon-${index}`}
              index={index}
              src={file.src}
              id={`policy-icon-${index}`}
              label={isValidString(file?.label) ? file?.label : getLabel(index)}
              originalName={file.originalName}
              onUpload={handlePolicyIconUpload}
              onRemove={handlePolicyIconRemove}
            />
          ))
        ) : (
          <div>No policy icons added.</div>
        )}
      </div>
    </div>
  );

  const referenceDocsUpload = () => (
    <div className="attachments">
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
        {referenceDocs?.length > 0 ? (
          referenceDocs.map((file, index) => (
            <Upload
              key={`ref-doc-${index}`}
              index={index}
              src={file.src}
              id={`ref-doc-${index}`}
              label={isValidString(file?.label) ? file?.label : getLabel(index)}
              originalName={file.originalName}
              onUpload={handleReferenceDocUpload}
              onRemove={handleReferenceDocRemove}
            />
          ))
        ) : (
          <div>No reference documents added.</div>
        )}
      </div>
    </div>
  );

  const onFinish = (values) => {
    let policyData = {
      title: values.title,
      details: values.details,
      policyIcon: [...policyIconFiles.filter((file) => file?.src)],
      referenceDocument: [...referenceDocs.filter((file) => file?.src)],
      description: values.description,
      businessTypeIds: [2, 8],
    };
    updatePolicyData(policyData);
  };
  const updatePolicyData = async (policyData) => {
    try {
      const response = await axios.post(
        `${BASE_API_CONFIG.baseURL}/policyUpdate`,
        policyData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        notification.success({
          message: "Success",
          description: "New policy has been updated successfully.",
        });
      } else {
        notification.error({
          message: "Failed",
          description: "Failed to submit.",
        });
      }
      history.goBack();
    } catch (error) {
      console.error("Error submitting policy update:", error);
    }
  };

  return (
    !loading && (
      <Card className="myexim-detail-card">
        <div
          className="myexim-table-title"
          style={{ display: "flex", alignItems: "center", gap: "12px" }}
        >
          <div
            onClick={() => {
              history.goBack();
            }}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <LeftOutlined style={{ fontSize: "24px" }} size="large" />
          </div>
          <span>Policy Update</span>
        </div>

        <Form form={form} onFinish={onFinish} className="gx-pt-4">
          <Row gutter={16}>
            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Title"
                name="title"
                rules={[
                  { required: true, message: "please enter policy title" },
                ]}
              >
                <Input placeholder="Enter policy title"></Input>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Details"
                name="details"
                rules={[
                  { required: true, message: "please enter policy details" },
                ]}
              >
                <Input placeholder="Enter policy details"></Input>
              </Form.Item>
            </Col>
          </Row>

          <Row className="gx-pt-5">
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Description"
                name="description"
                rules={[
                  { required: true, message: "please enter description" },
                ]}
              >
                <TextArea rows={10} placeholder="Enter policy description" />
              </Form.Item>
            </Col>
          </Row>

          <Row className="gx-pt-5">
            <Col span={24}>
              <div className="sub-header" style={{ marginLeft: "1px" }}>
                {" "}
                Policy Icon Images
              </div>
              <Form.Item
                labelCol={{ span: 12 }}
                wrapperCol={{ span: 12 }}
                name="policyIcon"
                rules={[
                  {
                    required: true,
                    message: "Policy icon is mandatory.",
                  },
                ]}
              >
                 {policyIconUpload()}
              </Form.Item>
              <Col>
                <div className="upload-tips gx-mt-4">
                  <div className="header" style={{ display: "flex" }}>
                    <InfoCircleOutlined />
                    &nbsp; Tips{" "}
                  </div>
                  <div className="desc">
                    <Badge
                      status="default"
                      text="Attach the Image / Video as reference to your requirement"
                    />
                    <br />
                    <Badge
                      status="default"
                      text="Supported file types: .jpg, .jpeg, .png .pdf"
                    />
                    <br />
                    <Badge
                      status="default"
                      text="File must not more than 5MB"
                    />
                    <br />
                    <Badge
                      status="default"
                      text="Make sure you have good resolution"
                    />
                    <br />
                    <Badge
                      status="default"
                      text="Photo resolution must be more than 600x600 resolution"
                    />
                    <br />
                  </div>
                </div>
              </Col>
            </Col>
          </Row>

          <Row className="gx-pt-5">
            <Col span={24}>
              <div className="sub-header" style={{ marginLeft: "1px" }}>
                {" "}
                Reference documents
              </div>
              <Form.Item
                labelCol={{ span: 12 }}
                wrapperCol={{ span: 12 }}
                name="referenceDocument"
                rules={[
                  {
                    required: false,
                    message: "Attachments are optional.",
                  },
                ]}
              >
                 {referenceDocsUpload()}
              </Form.Item>
              <Col>
                <div className="upload-tips gx-mt-4">
                  <div className="header" style={{ display: "flex" }}>
                    <InfoCircleOutlined />
                    &nbsp; Tips{" "}
                  </div>
                  <div className="desc">
                    <Badge
                      status="default"
                      text="Attach the Image / Video as reference to your requirement"
                    />
                    <br />
                    <Badge
                      status="default"
                      text="Supported file types: .pdf"
                    />
                    <br />
                    <Badge
                      status="default"
                      text="File must not more than 5MB"
                    />
                    <br />
                    <Badge
                      status="default"
                      text="Make sure you have good resolution"
                    />
                    <br />
                    <Badge
                      status="default"
                      text="Photo resolution must be more than 600x600 resolution"
                    />
                    <br />
                  </div>
                </div>
              </Col>
            </Col>
          </Row>

          <Row className="gx-pt-5">
            <Col span={24}>
              <Form.Item className="gx-text-center">
                <div
                  className="gx-mr-3"
                  style={{
                    justifyContent: isMobile ? "center" : "end",
                    display: "flex",
                    flex: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    type="secondary"
                    size="large"
                    style={{ width: 150 }}
                    onClick={() => {
                      history.goBack();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    style={{ width: 150 }}
                  >
                    Submit
                  </Button>
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    )
  );
};

export default UpdatePolicyDetails;
